import { Component, Entity, System } from "ecsy";
import { Triggered } from "../components";
import { getId } from "../entityFactory";
import { Game } from "../game";
import { selectAndFilter, TargetType, TriggeredEffect, TriggerScope } from "../triggeredEffects";
import { addComponent, deepCopy } from "../utils";

export let effectQueue = new Array<{ source: Entity, effect: TriggeredEffect, other?: Entity }>();

export class TriggeredEffectSystem extends System {
	game: Game;
	private oneShotComponentsToRemove = new Array<{ entity: Entity, component: new () => Component }>();

	constructor(world: any, attributes: any) {
		// @ts-ignore
		super(world, attributes);
		this.game = attributes.game;
	}

	execute() {
		for (const oneShot of this.oneShotComponentsToRemove) {
			if (getId(oneShot.entity) !== null && oneShot.entity.hasComponent(oneShot.component)) {
				oneShot.entity.removeComponent(oneShot.component);
			}
		}

		while (this.queries.triggered.results.length > 0) {
			const entity = this.queries.triggered.results[0];
			entity.removeComponent(Triggered);
		}

		for (const item of effectQueue) {
			const creator = item.source;
			const effect = item.effect;
			const selector = effect.targetSelector || { type: TargetType.Self };
			const filters = effect.filters || [];
			const scope = effect.scope || TriggerScope.Permanent;

			const targets = selectAndFilter(selector, filters, creator, this.game, item.other);

			//Run the effect on all its targets, which means add its component
			for (const target of targets) {
				const values = effect.component.needsDeepCopy ? deepCopy(effect.component.values) : effect.component.values;
				addComponent(target, effect.component.component, values);
				if (scope === TriggerScope.OneShot) {
					this.oneShotComponentsToRemove.push({
						entity: target,
						component: effect.component.component
					});
				}
			}

			//If the trigger went off
			if (targets.length > 0) {
				addComponent(creator, Triggered);
			}
		}
		effectQueue = [];
	}
}

TriggeredEffectSystem.queries = {
	triggered: { components: [Triggered] },
};


//Spawn a spot effect
		// const transform = creator.getComponent(Transform);
		// const owned = creator.getComponent(Ownership);
		// const playerId = owned ? owned.playerId : -1;
		// const sync = creator.getComponent(Sync);
		// if (transform) {
		// 	createEntity({
		// 		type: this.spawnee,
		// 		position: transform.position.xy,
		// 		playerId,
		// 		rotation: 0,
		// 		unsynced: !sync,
		// 		entityParameters: {
		// 			creatorSyncId: sync ? sync.id : undefined
		// 		}
		// 	});
		// }
